import { render, staticRenderFns } from "./practiceHistory.vue?vue&type=template&id=64730186&scoped=true"
import script from "./practiceHistory.vue?vue&type=script&lang=js"
export * from "./practiceHistory.vue?vue&type=script&lang=js"
import style0 from "./practiceHistory.vue?vue&type=style&index=0&id=64730186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64730186",
  null
  
)

export default component.exports